import React, { Component } from "react";
import { Table } from "reactstrap";

class FormExtended extends Component {
  constructor(props) {
    super(props);
    this.state = {
      grupo: "",
      valor: "",
      all: this.props.data,
      all2: this.props.data2,
      data: [],
      columns: [],
      ___rows: [],
      ___columns: [],
      pages: 0,
      activePage: 1,
      tableData: [],
      selectControls: {},
      xlsx: "",
    };
  }

  componentDidMount = () => {

  };


  setPagination = (columns, props) => {
    let { activePage } = this.state;
    this.setState(
      {
        columns,
        data: props.data,
      },
      () => {
        if (props.options && props.options.pagination) {
          let pages =
            props.data.length > this.state.itemsByPage
              ? props.data.length / this.state.itemsByPage + 1
              : 1;
          let width =
            this.state.columns.length > 2
              ? 100 / this.state.columns.length
              : 50;
          this.setState(
            {
              activePage,
              pages: parseInt(pages),
              width: parseInt(width),
            },
            () => this.buildRows()
          );
        } else this.setState({ tableData: props.data }, () => this.buildRows());
      }
    );
  };

  componentWillReceiveProps = (nextProps) => {
    let { columns } = nextProps;
    this.setPagination(columns, nextProps);

  };

  buildRows = () => {
    let { columns } = this.state;

    let ___rows = this.state.tableData.map((e, _index) => {
      let tds = [];
      if (e) {
        columns.forEach((column, index_) => {
          if (column.custom) {
            tds.push(
              <td
                key={index_}
                className={"tag-custom-value table-td table-td"}
                id={
                  e[column.key]
                    ? column.idTd
                      ? column.idTd
                      : e[column.key]
                    : e[column.key]
                }
                style={{ textAlign: "center" }}
              >
                {column.custom(e)}
              </td>
            );
          } else {
            tds.push(
              <td
                key={index_}
                className={"tag-custom-value table-td table-td"}
                id={
                  e[column.key]
                    ? column.idTd
                      ? column.idTd
                      : e[column.key]
                    : e[column.key]
                }
                style={{ textAlign: "center" }}
              >
                {e[column.key] ? e[column.key] : ""}
              </td>
            );
          }
        });
      }

      return <tr key={_index}>{tds}</tr>;
    });

    this.setState({ ___rows }, () => this.buildColumns());
  };


  buildColumns = () => {
    let ___columns = [];
    this.state.columns.forEach((e, index) => {
      let column = e.label
      ___columns.push(
        <th
          key={index}
          id={e.idTh ? e.idTh : index}
          className="title-custom-value"
        >
          {" "}
          <span

          >
            {column}
          </span>
        </th>
      );
    });
    this.setState({ ___columns });
  };



  render() {
    return (
      < >
        <Table
          responsive
          className={
            this.props.type === "GENERIC"
              ? "table-height table table-sticky table-bordered"
              : ""
          }
        >
          <thead style={{ textAlign: "center" }}>
            <tr>{this.state.___columns}</tr>
          </thead>
          <tbody className="table-body" style={{ textAlign: "center" }}>{this.state.___rows}</tbody>
        </Table>
      </>
    );
  }
}
export default FormExtended;
